export default function generateCSSRule(selector, cssDeclaration) {
  return selector + "{" + cssDeclaration + "}";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela-utils/es/generateCSSRule.js
// module id = 336
// module chunks = 0